import { api, errMsg } from "@/api";

const LS_STORE = (slug) => `hotspot_store:${slug}`;
const LS_PENDING = "hotspot_pending_orders";

export const newRef = () => `ref-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const cacheStore = (slug, data) => {
  try { localStorage.setItem(LS_STORE(slug), JSON.stringify({ ...data, cached_at: Date.now() })); } catch { /* penuh */ }
};

export const getCachedStore = (slug) => {
  try {
    const raw = localStorage.getItem(LS_STORE(slug));
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

export const getPending = () => {
  try { return JSON.parse(localStorage.getItem(LS_PENDING) || "[]"); } catch { return []; }
};

export const savePending = (list) => {
  try { localStorage.setItem(LS_PENDING, JSON.stringify(list)); } catch { /* penuh */ }
};

export const isNetworkError = (e) => !e?.response;

export async function flushPending(slug) {
  const list = getPending();
  const out = [];
  for (const p of list) {
    if (p.slug !== slug || p.state !== "pending") { out.push(p); continue; }
    try {
      await api.post(`/public/stores/${slug}/orders`, p.payload);
      out.push({ ...p, state: "sent", sent_at: Date.now() });
    } catch (e) {
      if (isNetworkError(e)) out.push(p);
      else out.push({ ...p, state: "failed", error: errMsg(e, "Ditolak server") });
    }
  }
  savePending(out);
  return out;
}
